// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/admin", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const res = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", "/admin");
        nav("/admin", { replace: true, state: { user: res.data } });
      } catch {
        nav("/admin", { replace: true });
      }
    })();
  }, [location, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-center">
        <Loader2 className="animate-spin text-teal mx-auto mb-4" size={40} />
        <p className="font-serif text-navy text-xl">Signing you in…</p>
      </div>
    </div>
  );
}
